export const SEND_CONTACT_INQUIRY = 'send-contact-inquiry';
const sendContactInquiry = ({ fullName, email, phone, message }) => ({
  type: SEND_CONTACT_INQUIRY,
  payload: { fullName, email, phone, message },
});
export default sendContactInquiry;
